import './EndFrame.css';

import React from 'react';
import { CSSTransition } from 'react-transition-group';
import STATUS from '../Constants';

const EndFrame = (props) => {
  return (
    <CSSTransition
      in={props.status === STATUS.GAME_END}
      timeout={350}
      exit={false}
      unmountOnExit
      classNames="fade-up">
      <div className="EndFrame flex flex--align-c flex--justify-c">
        <div className="wrapper">
          <div>
            <h1 className="title-lg">Well played!</h1>
            <h2 className="title-sm">You successfully matched all the cards.</h2>

            <button className="button" onClick={props.callback}>Play again</button>
          </div>

          <div>
            <div className="content">
              <p>Now that you know some of the basics, learn more about the house advantage, randomness and the difference between skill and chance-based games.</p>
            </div>

            <a href="https://www.gamesense.com/play-better.html" target="_blank" rel="noopener" className="button">Learn more</a>
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}

export default EndFrame;



// WEBPACK FOOTER //
// ./src/components/du/Game/EndFrame/EndFrame.js